import i18n, { TFunction } from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import { ENV } from '@/constants/env';

import { DEFAULT_NS, NAMESPACES, RESOURCES } from './@type/i18next/resources';
import { LOCALE_KEYS } from './constants/languages';

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        debug: false,
        resources: RESOURCES,
        lng: ENV.DEFAULT_APP_LOCALE,
        ns: NAMESPACES,
        defaultNS: DEFAULT_NS,
        fallbackLng: ENV.DEFAULT_APP_LOCALE,
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
            formatSeparator: ',',
        },
        react: { useSuspense: false },
    });

i18n.languages = LOCALE_KEYS;

export const t = i18n.t;
export const language = i18n.language;
export const resolvedLanguage = i18n.resolvedLanguage;
export const getSpecificT = <T extends keyof (typeof RESOURCES)['es']>(ns: T): TFunction<'events'> =>
    i18n.getFixedT(null, ns);

export default i18n;
